import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-executions',
  templateUrl: './executions.component.html',
  styleUrls: ['./executions.component.scss']
})
export class ExecutionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
